import { SignIn } from '@clerk/react';
import { Container, Center } from '@mantine/core';

const LoginPage = () => {
  return (
    <Container size="sm" py="xl">
      <Center>
        <SignIn routing="path" path="/login" signUpUrl="/register" />
      </Center>
    </Container>
  );
};

export default LoginPage;
